// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconTooltip: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15">
            <path
                fill="currentColor"
                d="M7,14 C9.50085945,14 11.8117485,12.6658072 13.0621784,10.5 C14.3126076,8.33419275 14.3126076,5.66580766 13.0621784,3.5 C11.8117485,1.33419275 9.50085945,0 7,0 C4.49914117,0 2.18825175,1.33419275 0.937822178,3.5 C-0.312607393,5.66580766 -0.312607393,8.33419275 0.937822178,10.5 C2.18825175,12.6658072 4.49914117,14 7,14 Z M4.64296915,4.51992154 C4.8589846,3.91015625 5.43867244,3.5 6.08671923,3.5 L7.68085952,3.5 C8.63515623,3.5 9.40625031,4.27382779 9.40625031,5.22539079 C9.40625031,5.84335971 9.07539077,6.41484392 8.5394531,6.72382838 L7.65625031,7.22968733 C7.65078123,7.58515608 7.3582036,7.875 7.00000031,7.875 C6.63632835,7.875 6.34375031,7.58242154 6.34375031,7.21875 L6.34375031,6.84960938 C6.34375031,6.61445296 6.46953173,6.3984375 6.67460985,6.28085929 L7.88593765,5.58632821 C8.0144536,5.51250017 8.09375031,5.37578142 8.09375031,5.22812533 C8.09375031,4.99843717 7.90781315,4.81523371 7.68085952,4.81523371 L6.08671923,4.81523371 C5.99375065,4.81523371 5.9117194,4.87265658 5.8816411,4.96015608 L5.87070377,4.99296808 C5.75039144,5.33476537 5.37304761,5.51249975 5.03398485,5.39218742 C4.6949221,5.27187508 4.5144536,4.89453125 4.63476594,4.55546808 L4.64570327,4.52265608 L4.64296915,4.51992154 Z M6.12500031,9.625 C6.12500031,9.14175045 6.51675119,8.75 7.00000031,8.75 C7.48324986,8.75 7.87500031,9.14175045 7.87500031,9.625 C7.87500031,10.1082495 7.48324986,10.5 7.00000031,10.5 C6.51675119,10.5 6.12500031,10.1082495 6.12500031,9.625 Z"
                transform="translate(0 .75)"
            />
        </svg>
    );
};

export default React.memo(IconTooltip);
